<script>
import ChartingStockBookmark from './ChartingStockBookmark.vue';
import ChartingStockWorkspaceMembership from './ChartingStockWorkspaceMembership.vue';

export default {
    name: 'ChartingStockWorkspacePicker',
    components: { ChartingStockBookmark, ChartingStockWorkspaceMembership },
    props: {
        stock: { type: Object, default: null },
        favoriteFolders: { type: Array, default: () => [] },
        canUseFavorites: { type: Boolean, default: false },
        isLoading: { type: Boolean, default: false },
        loadError: { type: [Object, String], default: null },
        isMutating: { type: Boolean, default: false },
        error: { type: String, default: '' }
    },
    data: () => ({ popover: null, attemptedChange: false }),
    computed: {
        stockKey() { return this.stock?.ticker + ':' + this.stock?.direction; }
    },
    watch: { stockKey() { this.popover?.hide(); this.attemptedChange = false; } },
    mounted() { this.popover = this.$refs.popover; },
    methods: {
        toggle(event) {
            if (!this.popover?.visible) this.attemptedChange = false;
            this.popover?.toggle(event);
            if (this.popover?.visible) this.$nextTick(() => this.popover.$el.focus());
        },
        toggleFolder(folderName) {
            this.attemptedChange = true;
            this.$emit('toggle-folder', { stock: this.stock, folderName });
        },
        handleKeydown(event) {
            if (event.key === 'Escape') {
                event.preventDefault();
                event.stopPropagation();
                this.popover?.hide({ restoreFocus: true });
            }
        }
    }
};
</script>

<template>
    <span class="charting-stock-workspace-picker">
        <ChartingStockBookmark
            v-if="stock && stock.ticker"
            :ticker="stock.ticker"
            :folder-names="stock.folderNames || []"
            :can-use-favorites="canUseFavorites"
            :is-mutating="isMutating"
            :expanded="Boolean(popover && popover.visible)"
            @click="toggle"
        />
        <Popover ref="popover" class="charting-stock-workspace-popover" tabindex="-1" :aria-label="'Guardar ' + (stock && stock.ticker)" @keydown.native="handleKeydown">
            <div class="charting-stock-workspace-popover__title">Guardar {{ stock && stock.ticker }}</div>
            <ChartingStockWorkspaceMembership
                :stock="stock"
                :favorite-folders="favoriteFolders"
                :can-use-favorites="canUseFavorites"
                :is-loading="isLoading"
                :load-error="loadError"
                :is-mutating="isMutating"
                :error="attemptedChange ? error : ''"
                @toggle-folder="toggleFolder"
                @retry="$emit('retry')"
            />
        </Popover>
    </span>
</template>

<style scoped>
.charting-stock-workspace-picker { display: inline-flex; flex: 0 0 auto; }
.charting-stock-workspace-popover { width: 19rem; max-width: calc(100vw - 1rem); max-height: min(28rem, calc(100dvh - 1rem)); padding: 0.75rem; outline: none; }
.charting-stock-workspace-popover__title { padding: 0.3rem 0.5rem 0.6rem; font-size: 0.9rem; font-weight: 600; color: var(--p-text-color); }
</style>
